import React, { Component } from 'react';
import ReactCrop, { makeAspectCrop } from 'react-image-crop';
import classnames from 'classnames';

const MIN_CROP_SIZE = 36; // in pixels
const MIN_CROP_PERCENT = 5;

const isNumber = (num) => typeof num === 'number';

const getInnerCrop = (crop, imgAspect) => {
  if (isNumber(crop.height) && isNumber(crop.width)) {
    return crop;
  }

  if (crop.aspect) {
    return makeAspectCrop(
      {
        ...crop,
        height: isNumber(crop.height) ? crop.height : crop.width / crop.aspect,
        width: isNumber(crop.width) ? crop.width : crop.height * crop.aspect,
      },
      imgAspect
    );
  }

  return { height: 100, width: 100, x: 0, y: 0 };
};

const getImageHeight = (imageSizes, modalDialogSizes = {}) => {
  const { naturalWidth, naturalHeight } = imageSizes;
  const isHigherThanCropDialog = naturalHeight > modalDialogSizes.height;
  const imageAspectBiggerThanModalAspect =
    naturalWidth / naturalHeight > modalDialogSizes.width / modalDialogSizes.height;

  if (isHigherThanCropDialog) {
    if (imageAspectBiggerThanModalAspect) {
      return 'auto';
    }
    return '100%';
  }

  return 'auto';
};

const hasSizesChanged = (sizes, prevSizes) =>
  sizes.viewportHeight !== prevSizes.viewportHeight ||
  sizes.viewportWidth !== prevSizes.viewportWidth ||
  sizes.orientation !== prevSizes.orientation;

const getMinCropSize = ({ width, height }, minCropSize) => {
  const minHeightPercentage = (100 * minCropSize) / height;
  const minWidthPercentage = (100 * minCropSize) / width;

  return { minWidthPercentage, minHeightPercentage };
};

class ImageCrop extends Component {
  cropDialogNode;
  static defaultProps = {
    crop: {},
  };

  constructor(props) {
    super(props);

    this.state = {
      pixelCrop: {},
      imgAspect: null,
      imgHeight: 'auto',
      minWidthPercentage: MIN_CROP_PERCENT,
      minHeightPercentage: MIN_CROP_PERCENT,
    };

    this.onChange = this.onChange.bind(this);
    this.onImageLoaded = this.onImageLoaded.bind(this);
    this.setCropDialogNode = this.setCropDialogNode.bind(this);
    this.setDefaultCropSizes = this.setDefaultCropSizes.bind(this);
    this.onSizesChange = this.onSizesChange.bind(this);
  }

  componentDidUpdate(prevProps) {
    if (hasSizesChanged(prevProps, this.props)) {
      this.onSizesChange();
    }
  }

  onChange(crop, pixelCrop) {
    const { onChange } = this.props;
    const { minWidthPercentage, minHeightPercentage } = this.state;

    // prevent crop min sizes
    if (crop.width < minWidthPercentage || crop.height < minHeightPercentage) {
      return;
    }

    this.setState({ pixelCrop });
    onChange(crop, pixelCrop);
  }

  onSizesChange() {
    const { image } = this.state;
    this.setDefaultCropSizes(image);
  }

  onImageLoaded(image) {
    const { naturalWidth, naturalHeight } = image;
    const width = image.width || naturalWidth;
    const height = image.height || naturalHeight;
    const imgAspect = width / height;

    this.setState(
      {
        imgAspect,
      },
      () => this.setDefaultCropSizes(image)
    );
  }

  setCropDialogNode(node) {
    this.cropDialogNode = node;
  }

  setDefaultCropSizes(image) {
    const { naturalWidth, naturalHeight } = image;
    const { minWidthPercentage, minHeightPercentage } = getMinCropSize(
      { height: image.height, width: image.width },
      MIN_CROP_SIZE
    );

    const modalDialogSizes = this.cropDialogNode && this.cropDialogNode.getBoundingClientRect();
    const imgHeight = getImageHeight({ naturalWidth, naturalHeight }, modalDialogSizes);

    this.setState({
      image,
      minWidthPercentage,
      minHeightPercentage,
      imgHeight,
    });
  }

  render() {
    const { crop, ...otherProps } = this.props;
    const { imgHeight, pixelCrop, imgAspect, minWidthPercentage, minHeightPercentage } = this.state;
    const innerCrop = getInnerCrop(crop, imgAspect);

    return (
      <div
        ref={this.setCropDialogNode}
        className={classnames('image-crop', {
          'image-crop--no-height-handles': !crop.aspect && pixelCrop.width < 80,
          'image-crop--no-width-handles': !crop.aspect && pixelCrop.height < 80,
        })}
      >
        {/* @ts-ignore TS(2769): No overload matches this call. */}
        <ReactCrop
          {...otherProps}
          style={{ height: imgHeight }}
          keepSelection
          crop={innerCrop}
          onChange={this.onChange}
          minWidth={minWidthPercentage}
          minHeight={minHeightPercentage}
          onImageLoaded={this.onImageLoaded}
        />
      </div>
    );
  }
}

export default ImageCrop;
